export function controlButtonClearInput() {
    const inputGroup = document.querySelectorAll(".input-group")

    inputGroup.forEach((group, index) => {
        const btnClear = group.querySelector("[data-action=clear]")

        if (btnClear) {
            btnClear.style.display = "none"
        }

        if (inputGroup[index].classList.contains("input-date-group")) {
            group.querySelector("input").addEventListener("blur", (input) => {
                if (input.target.value.length >= 1) {
                    btnClear.style.display = "block"

                    btnClear.addEventListener("click", () => {
                        input.target.value = ""
                        btnClear.style.display = "none"
                    })
                } else {
                    btnClear.style.display = "none"
                }
            })
        } else {
            if (group.querySelector("input")) {
                group.querySelector("input").addEventListener("change", (input) => {
                    setTimeout(function() {
                        if (input.target.value.length >= 1 && !input.target.classList.contains("error")) {
                            btnClear.style.display = "block"

                            btnClear.addEventListener("click", () => {
                                input.target.value = ""
                                btnClear.style.display = "none"
                            })
                        } else {
                            btnClear.style.display = "none"
                        }
                    }, 300);
                })
            }
        }
    })
}
